module.exports = "../../../../platform/assets/pageMainIcon/business_yewuchulilei1.svg";